import React from 'react';
import { motion } from 'framer-motion';
export function OffersSection() {
  const offers = [{
    image: 'https://assets.cdn.filesafe.space/3SQqBp51ZHIpTGzJ3Vu1/media/6a2bf324e5084c4b71a5878f.jpg',
    imageAlt: 'Cursuri online individuale',
    title: 'Cursuri Online',
    subtitle: 'Învață în ritmul tău',
    benefits: ['Acces pe viață la cursul ales', 'Materiale video structurate pas cu pas', 'Tehnici practice de aplicat acasă', 'Informație clară, fără termeni medicali', 'Suport tehnic inclus'],
    btnText: 'Vezi Cursurile',
    link: '/magazin',
    featured: false
  }, {
    image: 'https://assets.cdn.filesafe.space/3SQqBp51ZHIpTGzJ3Vu1/media/6a2bf324e5084c4b71a5878f.jpg',
    imageAlt: 'Programul CRESC',
    title: 'Programul CRESC',
    subtitle: 'Colecția completă + Suport',
    benefits: ['Toate cele 6 cursuri din colecție', 'Apeluri săptămânale de grup cu Cristina', 'Materiale practice și PDF-uri de lucru', 'Acces la comunitatea de mame', 'Ghidare pas cu pas timp de 6 luni'],
    btnText: 'Descoperă Programul',
    link: '/cresc',
    featured: true,
    badge: 'RECOMANDAT'
  }, {
    image: 'https://assets.cdn.filesafe.space/3SQqBp51ZHIpTGzJ3Vu1/media/6a2bf324e5084c4b71a5878f.jpg',
    imageAlt: 'Evaluare online',
    title: 'Evaluare Online',
    subtitle: 'Ședință individuală 1:1',
    benefits: ['Analiză video trimisă în avans', 'Ședință online de 45 de minute', 'Raport de evaluare detaliat', 'Plan de intervenție personalizat', 'Claritate asupra pașilor următori'],
    btnText: 'Programează aici',
    link: '/evaluarecadou',
    featured: false
  }];
  return <section className="bg-brand-ivory section-padding relative overflow-hidden" data-id="element-253">
      {/* Decorative Background Arc */}
      <svg className="absolute bottom-0 left-0 w-full h-[400px] text-brand-beige pointer-events-none" viewBox="0 0 1440 400" preserveAspectRatio="none" data-id="element-254">
        <path d="M0,400 C320,200 640,0 1440,200 L1440,400 L0,400 Z" fill="currentColor" data-id="element-255" />
      </svg>

      <div className="container-custom relative z-10" data-id="element-256">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-16" data-id="element-257">
          <h2 className="text-[32px] md:text-[42px] mb-4" data-id="element-258">
            Alege programul potrivit pentru tine și copilul tău
          </h2>
          <p className="text-[16px] md:text-[18px] text-brand-textSecondary" data-id="element-259">
            Două variante, același drum spre dezvoltarea armonioasă a copilului
            tău.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-stretch mt-12" data-id="element-260">
          {offers.map((offer, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          delay: index * 0.15,
          duration: 0.5
        }} className={`relative flex flex-col bg-white rounded-[24px] overflow-visible transition-all duration-300 ${offer.featured ? 'border-2 border-brand-gold shadow-card-hover md:-translate-y-4 z-10' : 'border border-[#E5E5E5] shadow-sm hover:border-brand-gold hover:shadow-card mt-0 md:mt-4'}`} data-id="element-261">
              {offer.featured && <div className="absolute -top-4 left-1/2 -translate-x-1/2 z-20 bg-brand-gold text-brand-navy font-montserrat font-bold text-[12px] uppercase tracking-[0.15em] px-6 py-2 rounded-full shadow-md whitespace-nowrap" data-id="element-262">
                  {offer.badge}
                </div>}

              {/* Image Thumbnail Area */}
              <div className="relative w-full h-[200px] overflow-hidden group rounded-t-[22px]" data-id="element-263">
                <img src={offer.image} alt={offer.imageAlt} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-264" />
                <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/40 via-brand-navy/10 to-transparent" data-id="element-265"></div>

                {/* Subtle brand accent overlay */}
                <div className={`absolute bottom-0 left-0 right-0 h-1 ${offer.featured ? 'bg-brand-gold' : 'bg-brand-coral'}`} data-id="element-266"></div>
              </div>

              <div className="p-8 flex flex-col flex-grow" data-id="element-267">
                <div className="mb-6 text-center" data-id="element-268">
                  <h3 className="font-playfair font-bold text-[24px] text-brand-navy mb-2" data-id="element-269">
                    {offer.title}
                  </h3>
                  <p className="font-montserrat font-medium text-[14px] text-brand-textSecondary" data-id="element-270">
                    {offer.subtitle}
                  </p>
                </div>

                <ul className="space-y-4 mb-10 flex-grow" data-id="element-271">
                  {offer.benefits.map((benefit, i) => <li key={i} className="flex items-start gap-3" data-id="element-272">
                      <div className="mt-1 flex-shrink-0 w-5 h-5 rounded-full bg-brand-gold/20 flex items-center justify-center" data-id="element-273">
                        <span className="w-2 h-2 rounded-full bg-brand-gold" data-id="element-274"></span>
                      </div>
                      <span className="text-brand-text text-[15px]" data-id="element-275">
                        {benefit}
                      </span>
                    </li>)}
                </ul>

                <a href={offer.link} className="w-full text-center btn-primary" data-id="element-276">
                  {offer.btnText}
                </a>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}